import { Pipe, PipeTransform } from '@angular/core';

import { dynamicColumnWidth } from './column-width-utils';
import { CatalogItemValue } from 'app/modules/data/models/catalog';
import { SelectOptionMobile } from '@shared/models/catalog.service';

@Pipe({
  name: 'dynamicColumnWidth',
})
export class DynamicColumnPipe implements PipeTransform {
  public transform(
    column: SelectOptionMobile,
    data: CatalogItemValue[],
    fileColumnNames: string[],
    breakPointScreen: 0 | 1 | 2 | 3 | 4 | 5,
    isSortAvailable = false,
  ): string {
    const width = dynamicColumnWidth(data, column, fileColumnNames, breakPointScreen, isSortAvailable);
    return `${width}px`;
  }
}
